import { render, staticRenderFns } from "./BoxEncuestasSatisfaccion.vue?vue&type=template&id=0886d624&scoped=true&lang=pug"
import script from "./BoxEncuestasSatisfaccion.vue?vue&type=script&lang=js"
export * from "./BoxEncuestasSatisfaccion.vue?vue&type=script&lang=js"
import style0 from "./BoxEncuestasSatisfaccion.vue?vue&type=style&index=0&id=0886d624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0886d624",
  null
  
)

export default component.exports